import { paths } from '@mc/paths'
import {
  EventTypes,
  Locations,
  NavigationEvents,
  trackGoldStandardEvent,
  track,
  getPageSource,
} from '@mc/track-event'

type NavLevel =
  (typeof NavigationEvents.LEVELS)[keyof typeof NavigationEvents.LEVELS]

type NavLocation = (typeof Locations)[keyof typeof Locations]

export const trackNavClick =
  (
    /* eslint-disable default-param-last */
    action: string,
    level: NavLevel = NavigationEvents.LEVELS.PRIMARY,
    location: NavLocation = Locations.NAVIGATION,
    product?: string,
    /* eslint-enable default-param-last */
  ) =>
  () => {
    const pageSource = getPageSource()

    const eventProperties: {
      action: string
      level: NavLevel
      location: NavLocation
      page_source: string | undefined
      product?: string
    } = {
      action,
      level,
      location,
      page_source: pageSource,
    }

    if (product) {
      eventProperties.product = product
    }

    trackGoldStandardEvent(
      NavigationEvents.EVENTS.NAVIGATION_CLICKED,
      eventProperties,
    )
  }

const trackGiftPurchaseClick = () => {
  track(EventTypes.PURCHASE_CLICK, {
    page_source: 'Navigation',
    location: 'navigation',
    level: NavigationEvents.LEVELS.SECONDARY,
    href: paths.checkoutGift(),
    action: 'Gift MasterClass',
    content_type: 'product',
    // content_ids: 304,
    class: 'annual-pass',
  })
}

export const trackGiftCTAClick = (
  level: NavLevel = NavigationEvents.LEVELS.SECONDARY,
) => {
  trackNavClick('Gift MasterClass', level)()
  trackGiftPurchaseClick()
}

const trackViewPlansNavClick = (level: NavLevel) => {
  trackGoldStandardEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
    category: 'home-nav-header',
    action: 'View Plans',
    level,
    page_source: getPageSource(),
  })
}

const trackViewPlansPurchaseClick = (level: NavLevel) => {
  track(EventTypes.PURCHASE_CLICK, {
    page_source: getPageSource(),
    location: 'navigation',
    level,
    href: paths.checkout,
    action: 'View Plans',
  })
}

export const trackPlansClick = (level: NavLevel) => () => {
  trackViewPlansNavClick(level)
  trackViewPlansPurchaseClick(level)
}

export const trackLoginClick = () => {
  trackNavClick('Log In', NavigationEvents.LEVELS.PRIMARY)()
}

export const trackLogoClick = () => {
  trackNavClick('MC Logo', NavigationEvents.LEVELS.PRIMARY)()
}

export const trackNavigationClick = (
  action: string,
  level: NavLevel,
  location: NavLocation,
  product?: string,
) => {
  const properties: Record<
    string,
    string | number | boolean | object | null | undefined
  > = {
    action,
    level,
    location,
    page_source: getPageSource(),
  }

  if (product) {
    properties.product = product
  }
  const options: { integrations?: Record<string, boolean> } = {
    integrations: {
      All: true,
      'Bing Ads': false,
      'Facebook CAPI': false,
      'Facebook Pixel': false,
      'Google AdWords New': false,
      'Google Tag Manager': false,
      Hotjar: false,
      ShareASale: false,
      TikTok: false,
    },
  }

  track(NavigationEvents.EVENTS.NAVIGATION_CLICKED, properties, options)
}
